import { ApiSchema } from "@/api/ApiClient";
import { GenericModelApi } from "./GenericModelApi";
import { ApiResourceFormData } from "@/formTypes/ApiResourceDataType";

export type ApiResourceDataType = Partial<ApiSchema["ApiResource"]["type"] & ApiResourceFormData>;

class Api extends GenericModelApi<"ApiResource", ApiResourceDataType> { }

export const ApiResourceApi = new Api("ApiResource", "label")
